import * as React from 'react';
import {Modal, TextArea as SemanticTextArea} from "semantic-ui-react";
import {SyntheticEvent} from "react";
import {IVirtualizedTableCellComponentProps} from "../../VirtualizedTableInterfaces";
import AutoTextArea from "react-textarea-autosize";

interface TextAreaProps extends IVirtualizedTableCellComponentProps {
}

interface TextAreaState {
    value: string | undefined;
    closeOnDimmerClick: boolean;
    textareaHeight: number;
    // flag used to re-trigger the render of textarea
    // so that it computes again the height after the text was updated by user
    hideTextarea: boolean;
}

export default class TextArea extends React.Component<TextAreaProps, TextAreaState> {
    constructor(props: TextAreaProps) {
        super(props);

        this.state = {
            value: undefined,
            closeOnDimmerClick: true,
            textareaHeight: 10,
            hideTextarea: false,
        };
    }

    componentDidMount() {
        this.setState({value: this.props.value});
        // @ts-ignore
        if (!this.props.isIndicator) {
            document.addEventListener("click", this.handleMouseRelease);
        }
    }

    componentWillUnmount() {
        // @ts-ignore
        if (!this.props.isIndicator) {
            document.removeEventListener("click", this.handleMouseRelease);
        }
    }

    private handleMouseRelease = (e: any) => {
        if (this.state.closeOnDimmerClick === false) {
            this.setState({closeOnDimmerClick: true});
        }
    }

    componentDidUpdate(prevProps: TextAreaProps) {
        if (this.props.value !== prevProps.value) {
            this.setState({value: this.props.value, hideTextarea: false});
        }
    }

    private saveChange = () => {
        const propsValue = this.props.value || "";
        const stateValue = this.state.value || "";
        if (propsValue !== stateValue) {
            this.props.onChange(this.state.value);
            this.setState({hideTextarea: true});
        }
    }

    private onChange = (e: SyntheticEvent) => {
        this.setState({value: (e.currentTarget as HTMLTextAreaElement).value});
    }

    private onClose = () => {
        this.saveChange();
        if (this.props.clearActiveRow) this.props.clearActiveRow();
    }

    private onOpen = () => {
        if (this.props.setActiveRow) this.props.setActiveRow();
    }

    private changeFocus = (input: any) => {
        let x = window.scrollX;
        let y = window.scrollY;
        input.focus();
        window.scrollTo(x, y);
    }

    private onHeightChange = (height: number, value: string) => {
        if (value === this.props.value) {
            this.setState({textareaHeight: height});
        }
    }

    public render() {
        const {uglyMode, editDialogHeader, readOnly, isIndicator} = this.props;
        const value: string = this.state.value ? this.state.value : "";
        if (uglyMode && !this.state.hideTextarea)
            return (
                <AutoTextArea
                    value={value}
                    style={{
                        width: "100%",
                        // sometimes, especially when the width is small, AutoTextArea put a scrollbar on the field
                        // even though it has enough space to grow
                        // therefore, this 20 is used more like an error margin
                        maxHeight: this.state.textareaHeight + 20,
                        height: this.state.textareaHeight + 20,
                        minHeight: this.state.textareaHeight + 20,
                        resize: 'none'
                    }}
                    onChange={this.onChange}
                    onBlur={this.saveChange}
                    disabled={readOnly}
                    onHeightChange={(height) => this.onHeightChange(height, value)}
                />
            );
        if (isIndicator) {
            return (
                <SemanticTextArea
                    className="width--100Percent text-area-modal"
                    value={value}
                    autoHeight={true}
                    disabled={readOnly}
                />
            );
        }
        return (
            <Modal
                onClose={this.onClose}
                id="modal-container"
                onOpen={this.onOpen}
                dimmer={'inverted'}
                closeOnDimmerClick={this.state.closeOnDimmerClick}
                trigger={
                    <div className="width--100Percent text-area-modal">
                        <SemanticTextArea
                            className="width--100Percent text-area-modal"
                            value={value}
                            autoHeight={true}
                            disabled={readOnly}
                        />
                        <div className='disabled_input' />
                    </div>
                }
            >
                {editDialogHeader &&
                    <Modal.Header>
                        <div className="display--flex justify-content--space-between">
                            <span>
                                {editDialogHeader.dialogTitle + " - "}
                                <span style={{color: "#950014"}}>{editDialogHeader.optionCode}</span>
                                {" - "}
                                <span style={{color: "#950014"}}>{editDialogHeader.optionType}</span>
                            </span>
                            <span>{editDialogHeader.editingColumn}</span>
                        </div>
                    </Modal.Header>
                }
                <Modal.Content>
                    <SemanticTextArea
                        className="width--100Percent"
                        value={value}
                        onChange={this.onChange}
                        id="dialog-textArea"
                        disabled={readOnly}
                        ref={(input) => input && this.changeFocus(input)}
                        onFocus={(e: any) => {
                            let val = e.target.value;
                            e.target.value = '';
                            e.target.value = val;
                        }}
                        onMouseDown={() => this.state.closeOnDimmerClick && this.setState({closeOnDimmerClick: false})}
                    />
                </Modal.Content>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Table/components/basic/TextArea.tsx